import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getHomeCategories } from '../../services/api';

const defaultCategories = [
  {
    id: 'almonds',
    name: 'Almonds',
    image: 'https://images.unsplash.com/photo-1508061253366-f7da158b6d46?w=400',
  },
  {
    id: 'cashews',
    name: 'Cashews',
    image: 'https://images.unsplash.com/photo-1604068549290-dea0e4a305ca?w=400',
  },
  {
    id: 'walnuts',
    name: 'Walnuts',
    image: 'https://images.unsplash.com/photo-1563412116625-5da7f0fa1520?w=400',
  },
  {
    id: 'pistachios',
    name: 'Pistachios',
    image: 'https://images.unsplash.com/photo-1525706823953-b1c12413ef8c?w=400',
  },
  {
    id: 'dates',
    name: 'Dates',
    image: 'https://images.unsplash.com/photo-1580178012579-230a94cf17e6?w=400',
  },
  {
    id: 'raisins',
    name: 'Raisins & Berries',
    image: 'https://images.unsplash.com/photo-1596273501048-9f5e7da16485?w=400',
  },
];


const CategoryGrid = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getHomeCategories();
        if (response.data && response.data.length > 0) {
          setCategories(response.data);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchCategories();
  }, []);

  const displayCategories = categories.length > 0
    ? categories.map((cat, index) => ({
        id: cat._id,
        name: cat.CategoryName,
        image: cat.image,
      }))
    : defaultCategories;

  return (
    <Box sx={{ py: 6, bgcolor: '#fff' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 5 }}>
          <Typography
            variant="overline"
            sx={{ color: '#8B4513', fontWeight: 600, letterSpacing: 2 }}
          >
            Browse By
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, color: '#3E2723', mt: 1 }}
          >
            Shop by Category
          </Typography>
        </Box>

        <Grid container spacing={3} justifyContent="center">
          {displayCategories.map((category) => (
            <Grid item xs={6} sm={4} md={2} key={category.id}>
              <Paper
                onClick={() => navigate(`/filter/${category.id}`)}
                elevation={0}
                sx={{
                  cursor: 'pointer',
                  textAlign: 'center',
                  p: 2,
                  borderRadius: 3,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 24px rgba(0,0,0,0.1)',
                  },
                }}
              >
                <Box
                  sx={{
                    width: { xs: 80, md: 100 },
                    height: { xs: 80, md: 100 },
                    borderRadius: '50%',
                    overflow: 'hidden',
                    mx: 'auto',
                    mb: 2,
                    border: '3px solid #f5ebe0',
                  }}
                >
                  <img
                    src={category.image}
                    alt={category.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </Box>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, color: '#3E2723' }}
                >
                  {category.name}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CategoryGrid;
